import * as React from 'react';

import Page from 'components/page/Page';

import { __t, applyTranslations } from 'utils/language';

import './sov-error-page-consumer-insights.scss';

applyTranslations(require('locales/common/collabary-common.i18n.json'));
applyTranslations(require('./sov-error-page-consumer-insights.i18n.json'));

const MSG_KEY = 'sov_error_page_consumer_insights';

const SOVErrorPageConsumerInsights = (): JSX.Element => (
  <Page
    documentTitle={`${__t(`${MSG_KEY}.page_title`)}`}
  >
    <div className="sov-error-page-consumer-insights">
      {__t(`${MSG_KEY}.messages.not_authenticated`)}
    </div>
  </Page>
);

export default SOVErrorPageConsumerInsights;
